import React from "react";
import { useBreakpoint } from "gatsby-plugin-breakpoints";
import { Container } from "components/Design/Grid/Grid";
const SupportLandingSection = ({
  title,
  contactUsContents,
  supportForm,
  otherContents,
}) => {
  const breakpoints = useBreakpoint();
  return (
    <div>
      <h1 className="hidden lg:block text-h1 text-gray-text mt-60 mb-24 text-center font-semibold">
        {title}
      </h1>
      <div className="flex flex-wrap max-w-1000 mx-auto mb-40 lg:flex-nowrap">
        <div className="flex flex-col flex-none space-y-16 w-full order-2 lg:w-320 lg:order-1">
          {breakpoints.md && otherContents}
          <div className="lg:hidden">
            <Container>{contactUsContents}</Container>
          </div>
          <div className="hidden lg:block">{contactUsContents}</div>
        </div>
        <div className="lg:ml-20 order-1 lg:order-2 w-full">{supportForm}</div>
      </div>
    </div>
  );
};

export default SupportLandingSection;
